export const CREATE_MOVIMIENTO_INTRADAY = `
  mutation createMovimientoIntraday($movimientoIntraday: inputMovimientoIntraday_Dto!) {
    createMovimientoIntraday(movimientoIntraday: $movimientoIntraday) {
      id
    }
  }
`;

export const GET_ALL_MOVIMIENTOS_INTRADAY = `
  query {
    getAllMovimientoIntraday {
      id
      monto
      tipoCambio
      estado
      fechaOperacion
      comision
      cuentaCargo {
        id
        nombre
        tipo
      }
      cuentaDestino {
        id
        nombre
        tipo
      }
      fechaReprogramacion
      fechaEfectiva
    }
  }
`;

export const GET_INCOME_RECONCILIATION_INTRADAY_CANDIDATES = `
  query getIncomeReconciliationIntradayCandidates($mode: String!, $cuentaBancoId: String, $limit: Float, $nextToken: String) {
    getIncomeReconciliationIntradayCandidates(mode: $mode, cuentaBancoId: $cuentaBancoId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        monto
        tipoCambio
        estado
        fechaOperacion
        comision
        cuentaCargo {
          nombre
          tipo
        }
        cuentaDestino {
          nombre
          tipo
        }
      }
      nextToken
      hasMore
    }
  }
`;

export const GET_MOVIMIENTO_INTRADAY = `
  query getMovimientoIntraday($id: String!) {
    getMovimientoIntraday(id: $id) {
      id
      monto
      tipoCambio
      estado
      fechaOperacion
      comision
      cuentaCargo {
        id
        nombre
        tipo
      }
      cuentaDestino {
        id
        nombre
        tipo
      }
      fechaReprogramacion
      fechaEfectiva
    }
  }
`;
